function hasArrayShape(value: unknown): value is readonly unknown[] {
    return Array.isArray(value);
}

export function isArray(value: unknown): boolean {
    return hasArrayShape(value);
}

export function arrayValue(value: unknown): readonly unknown[] | null {
    return hasArrayShape(value) ? value : null;
}

export function snapshotArray<T>(value: readonly T[], validate: (entry: T, index: number, length: number) => void): readonly T[] | null {
    if (!isArray(value))
        return null;
    const length = value.length;
    const entries: T[] = [];
    for (let index = 0; index < length; index += 1) {
        if (!Object.hasOwn(value, index))
            return null;
        const entry = value[index];
        entries.push(entry);
        validate(entry, index, length);
    }
    return entries;
}
